module.exports = __webpack_public_path__ + "static/media/logo.6dd21a2c.png";